import api from 'api'

import {
  CACHE_TAG_ACCOUNT_GROUP_DETAILS,
  CACHE_TAG_ACCOUNT_LIST,
  CACHE_TAG_AGING_GROUP_DETAILS,
  CACHE_TAG_SUSPENSION_GROUP_DETAILS,
  CACHE_TAG_VACATION_HOLD_LIST,
  CACHE_TAG_WORK_ORDER_LIST,
} from '../cacheTagTypes'

import type { VacationHoldApi, VacationHoldListApi } from 'types/api/account/vacationHold'
import type { VacationHoldBody } from 'types/api/account/vacationHoldRequests'

type HoldArgs = { accountId: string; vacationHoldId: string }

const HOLD_WRITE_TAGS = [
  CACHE_TAG_VACATION_HOLD_LIST,
  CACHE_TAG_ACCOUNT_LIST,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_ACCOUNT_GROUP_DETAILS,
  CACHE_TAG_AGING_GROUP_DETAILS,
  CACHE_TAG_SUSPENSION_GROUP_DETAILS,
]

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getVacationHoldList: builder.query<VacationHoldListApi, { accountId: string; deleted?: boolean }>({
      query: ({ accountId, deleted = false }) => ({
        url: `/api/v1/core/accounts/${accountId}/vacation-holds?deleted=${deleted}`,
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_VACATION_HOLD_LIST],
    }),
    getVacationHoldDetails: builder.query<VacationHoldApi, HoldArgs>({
      query: ({ accountId, vacationHoldId }) => ({
        url: `/api/v1/core/accounts/${accountId}/vacation-holds/${vacationHoldId}`,
        method: 'GET',
      }),
    }),
    deleteVacationHold: builder.mutation<VacationHoldApi, HoldArgs>({
      query: ({ accountId, vacationHoldId }) => ({
        url: `/api/v1/core/accounts/${accountId}/vacation-holds/${vacationHoldId}`,
        method: 'DELETE',
      }),
      invalidatesTags: HOLD_WRITE_TAGS,
    }),
    createVacationHold: builder.mutation<VacationHoldApi, { accountId: string; data: VacationHoldBody }>({
      query: ({ accountId, data }) => ({
        url: `/api/v1/core/accounts/${accountId}/vacation-holds`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: HOLD_WRITE_TAGS,
    }),
    updateVacationHold: builder.mutation<VacationHoldApi, HoldArgs & { data: VacationHoldBody }>({
      query: ({ accountId, data, vacationHoldId }) => ({
        url: `/api/v1/core/accounts/${accountId}/vacation-holds/${vacationHoldId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: HOLD_WRITE_TAGS,
    }),
  }),
})

export const {
  useLazyGetVacationHoldListQuery,
  useLazyGetVacationHoldDetailsQuery,
  useDeleteVacationHoldMutation,
  useCreateVacationHoldMutation,
  useUpdateVacationHoldMutation,
} = extendedApi
